import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalRef } from '../../shared/globals/global-ref';
import { IEntityValidation } from '../../shared/interfaces/models/ientity-validation.model';
import { DictionaryBaseService } from '../../shared/services/dictionary-base.service';
import { UserContextService } from '../../shared/services/user-context.service';
import { IUserScoring } from './iuser-scoring.model';
import { IUserScoringQuery } from './iuser-scoring-query.model';

@Injectable({
  providedIn: 'root',
})
export class IUserScoringsService extends DictionaryBaseService<IUserScoring> {

  constructor(globalContext: GlobalRef, protected userContextSvc: UserContextService, protected http: HttpClient) {
    super(globalContext, userContextSvc, http);
    this.svcUrl += "UserBFScorings/"; 
  }

  getAverageScore(query: IUserScoringQuery): Observable<number> {
    const qstr = JSON.stringify(query);
    return this.http.get<number>(this.svcUrl + 'averageScore?query=' + qstr);
  }

  validate(model: IUserScoring): IEntityValidation {
    let res: IEntityValidation = { Valid: true };
    let valid = !(
      !(model.UserId || model.User) ||
      !(model.BusinessFunctionId || model.BusinessFunction) ||
      !model.Score
    );
    if (!valid) {
      res.Valid = false;
      res.Message = 'Не заполнены обязательные поля';
      return res;
    }    
    return res;
  }
}
